// Shared light-only routes that must not inherit Dia's dark document background.
// Everything else remains themed so redirects do not expose a white frame.
export const DIA_BOOT_THEME_EXCLUDED_PATHS: readonly string[] = ['/2step'];
